function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 150,
  r: 150,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.0266 205.873C75.0461 202.826 72 197.402 72 191.576V159.047C72 157.802 72.3335 156.602 72.9561 155.534C74.8905 152.199 79.1817 151.065 82.5168 153.022L155.935 195.822C160.226 198.335 162.872 202.916 162.872 207.896V241.603C162.872 243.137 162.449 244.671 161.649 245.983C159.225 249.941 154.067 251.186 150.109 248.762L80.0266 205.873ZM189.464 144.105C193.755 146.618 196.401 151.199 196.401 156.179V224.571C196.401 226.595 195.311 228.462 193.555 229.441L177.479 238.49C177.279 238.602 177.057 238.69 176.835 238.757V200.781C176.835 195.867 174.256 191.309 170.031 188.774L105.552 150.198V107.33C105.552 106.085 105.885 104.884 106.508 103.817C108.442 100.482 112.733 99.3479 116.068 101.304L189.464 144.105ZM221.593 93.5892C225.906 96.0794 228.552 100.704 228.552 105.685V205.584C228.552 207.629 227.418 209.519 225.617 210.497L210.386 218.724V149.175C210.386 144.262 207.807 139.725 203.605 137.19L137.702 97.6581V56.9915C137.702 55.7464 138.036 54.5457 138.636 53.4785C140.571 50.1433 144.862 49.0094 148.197 50.9438L221.593 93.5892Z",
  fill: "#00D395"
});

var SvgComp = function SvgComp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/COMP.94354443.svg";
export { ForwardRef as ReactComponent };